import React from 'react';
import renderRawHtml from '../../../../common/render_raw_html.js';
import StartButton from './start_button.js';

const Qualified = ({
  nextStep, title, descriptionTop,
  descriptionBottom, descriptionFooter,
  description
}) => {
  let createdDescription = description;
  if (!createdDescription) {
    createdDescription = descriptionTop;
  }

  return (
    <div className="survey-layout_content -start">
      <div className="survey-start">
        {
          !!title && <h1 className="survey-start_title" { ...renderRawHtml(title) } />
        }
        <div className="survey-start_description -centered">
          <span { ...renderRawHtml(createdDescription) } />
          {
            descriptionBottom &&
            <>
              <br />
              <span { ...renderRawHtml(descriptionBottom) } />
            </>
          }
        </div>
        {
          descriptionFooter &&
          <div className="survey-start_title" { ...renderRawHtml(descriptionFooter) } />
        }
        <StartButton nextStep={ () => { nextStep(); } } />
      </div>
    </div>
  );
};

export default Qualified;
